module.exports = __webpack_public_path__ + "assets/images/restaurant-02.02ba0574451a3f905888f86439ff40c9.svg";